const language=[
  {
      id: 1,
      Name: "Amharic",
      Code: "am"
  },
  {
     id: 2,
     Name: "Arabic",
     Code: "ar"
  },
  {
     id: 3,
     Name: "Basque",
     Code: "eu" 
  },
  {
     id: 4,
     Name: "Bengali",
     Code: "bn"
  },
  {
     id: 5,
     Name: "Portuguese (Brazil)",
     Code: "pt-BR"
  },
  {
     id: 6,
     Name: "Bulgarian",
     Code: "bg"
  },
  {
     id: 7,
     Name: "Catalan",
     Code: "ca"
  },
  {
     id: 8,
     Name: "Cherokee",
     Code: "chr" 
  },
  {
     id: 9,
     Name: "Croatian",
     Code: "hr" 
  },
  {
     id: 10,
     Name: "Czech",
     Code: "cs"  
  },
  {
     id: 11,
     Name: "Danish",
     Code: "da"  
  },
  {
     id: 12,
     Name: "English",
     Code: "en"
  },
  {
     id: 13,
     Name: "Filipino",
     Code: "fil"
  },
  {
     id: 14,
     Name: "Finnish",
     Code: "fi"
  },
  {
     id: 15,
     Name: "French",
     Code: "fr"
  },
  {
     id: 16,
     Name: "German",
     Code: "de"
  },
  {
     id: 17,
     Name: "Greek",
     Code: "el"
  },
  {
     id: 18,
     Name: "Gujarati",
     Code: "gu"  
  },
  {
     id: 19,
     Name: "Hebrew",
     Code: "iw"
  },
  {
     id: 20,
     Name: "Hindi",
     Code: "hi"
  },
  {
     id: 21,
     Name: "Hungarian",
     Code: "hu"
  },
  {
     id: 22,
     Name: "Icelandic",
     Code: "is"
  },
  {
     id: 23,
     Name: "Indonesian",
     Code: "id"
  },
  {
     id: 24,
     Name: "Italian",
     Code: "it"
  },
  {
     id: 25,
     Name: "Japanese",
     Code: "ja"
  },
  {
     id: 26,
     Name: "Kannada",
     Code: "kn"
  },
  {
     id: 27,
     Name: "Korean",
     Code: "ko"
  },
  {
     id: 28,
     Name: "Latvian	",
     Code: "lv"
  },
  {
     id: 29,
     Name: "Malay",
     Code: "ms"
  },
  {
     id: 30,
     Name: "Malayalam",
     Code: "ml"
  },
  {
     id: 31,
     Name: "Marathi",
     Code: "mr" 
  },
  {
     id: 32,
     Name: "Norwegian",
     Code: "no"
  },
  {
     id: 33,
     Name: "Polish",
     Code: "pl"
  },
  {
     id: 34,
     Name: "Portuguese (Portugal)",
     Code: "pt-PT"
  },
  {
     id: 35,
     Name: "Romanian",
     Code: "ro"
  },
  {
     id: 36,
     Name: "Russian",
     Code: "ru"
  },
  {
     id: 37,
     Name: "Serbian",
     Code: "sr"
  },
  {
     id: 38,
     Name: "Chinese",
     Code: "zh"
  },
  {
     id: 39,
     Name: "Slovak",
     Code: "sk"
  },
  {
     id: 40,
     Name: "Slovenian",
     Code: "sl"
  },
  {
     id: 41,
     Name: "Spanish",
     Code: "es"
  },
  { 
     id: 42,
     Name: "Swahili",
     Code: "sw"
  },
  {
     id: 43,
     Name: "Swedish",
     Code: "sv" 
  },
  {
     id: 44,
     Name: "Tamil",
     Code: "ta" 
  },
  {
     id: 45,
     Name: "Telugu",
     Code: "te" 
  },
  {
     id: 46,
     Name: "Thai",
     Code: "th" 
  },
  {
     id: 47,
     Name: "Turkish",
     Code: "tr" 
  },
  {
     id: 48,
     Name: "Urdu",
     Code: "ur" 
  },
  {
     id: 49,
     Name: "Ukrainian",
     Code: "uk"
  },
  {
     id: 50,
     Name: "Vietnamese",
     Code: "vi"
  },
  {
     id: 51,
     Name: "Welsh",
     Code: "cy"
  },


]

export default language;